import { TableCell, TableRow } from "@mui/material";
import type { FC } from "react";

import {
  formatDateDMY,
  NO_VALUE_DISPLAY,
  timezoneAdjustedDateToDayStartISO,
  useTimezone,
  type IApprovalBookingConflict,
} from "@ryde/shared";

import { RejectedBookingPassengerTableCell } from "./rejected-booking-passenger-table-cell";

interface IRejectedBookingsStatusMismatchRowProps {
  conflictRow: IApprovalBookingConflict;
}

export const RejectedBookingsStatusMismatchRow: FC<
  IRejectedBookingsStatusMismatchRowProps
> = ({ conflictRow }) => {
  const { timezone } = useTimezone();
  const { bookingId, passengerId, passengerFullName, date } = conflictRow;

  return (
    <TableRow data-e2e="rejected-bookings-status-mismatch-row">
      <TableCell>{bookingId ?? NO_VALUE_DISPLAY}</TableCell>
      <RejectedBookingPassengerTableCell passengerId={passengerId}>
        {passengerFullName}
      </RejectedBookingPassengerTableCell>
      <TableCell>
        {formatDateDMY(
          timezoneAdjustedDateToDayStartISO(date, timezone),
          timezone,
        )}
      </TableCell>
    </TableRow>
  );
};
